module.exports = __webpack_public_path__ + "static/media/security1.fa6587f2.jpg";